var map = {
	"./en": 17689,
	"./en.d": 36552,
	"./en.d.ts": 36552,
	"./en.js": 17689,
	"./es": 96153,
	"./es.d": 7943,
	"./es.d.ts": 7943,
	"./es.js": 96153,
	"./fr": 60463,
	"./fr.d": 11479,
	"./fr.d.ts": 11479,
	"./fr.js": 60463,
	"./nl": 58670,
	"./nl.d": 90896,
	"./nl.d.ts": 90896,
	"./nl.js": 58670,
	"./pl": 53026,
	"./pl.d": 25126,
	"./pl.d.ts": 25126,
	"./pl.js": 53026,
	"./pt": 19370,
	"./pt-PT": 29445,
	"./pt-PT.d": 42831,
	"./pt-PT.d.ts": 42831,
	"./pt-PT.js": 29445,
	"./pt.d": 85159,
	"./pt.d.ts": 85159,
	"./pt.js": 19370,
	"./ses": 55240,
	"./ses.d": 5135,
	"./ses.d.ts": 5135,
	"./ses.js": 55240,
	"./tr": 68551,
	"./tr.d": 80500,
	"./tr.d.ts": 80500,
	"./tr.js": 68551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45489;